import { getFromSessionStorage } from "../sessionStorage";
import { LANGUAGE_LS_KEY } from "../../static/sessionStorage";

export const getSavedLanguage = () => {
  const savedLang = getFromSessionStorage(LANGUAGE_LS_KEY);

  return savedLang || null;
};
